// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Building part type picker: header + grid of tiles (2 columns on phones, 3 from tablet up).
 * The host is the modal page (.ion-page, flex column): the grid scrolls, the header stays. */
:host {
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.category-picker__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: 16px 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.category-picker__header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
}

.category-picker__close {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.category-picker__close ion-icon {
  display: block;
  font-size: 22px;
}
.category-picker__close:hover, .category-picker__close:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-medium-rgb), 0.12);
}

.category-picker__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 16px 16px calc(16px + var(--ion-safe-area-bottom));
}

.category-picker__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  gap: 12px;
}
@media (min-width: 576px) {
  .category-picker__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.category-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 100%;
  min-height: 112px;
  padding: 18px 10px 16px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-radius: 12px;
  background: var(--ion-background-color, #fff);
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
}
.category-tile:hover, .category-tile:focus-visible {
  outline: none;
  border-color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.category-tile:active {
  transform: scale(0.98);
}
.category-tile__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
.category-tile__icon ion-icon {
  font-size: 26px;
}
.category-tile__name {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-environment-category/popup-environment-category.component.scss"],"names":[],"mappings":"AAAA;6FAAA;AAEA;EACE,4CAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,gEAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;AAGE;EAEE,aAAA;EACA,mDAAA;AAFJ;;AAMA;EACE,cAAA;EACA,gBAAA;EACA,2DAAA;AAHF;;AAMA;EACE,aAAA;EACA,gDAAA;EAGA,mBAAA;EACA,SAAA;AALF;AAOE;EARF;IASI,gDAAA;EAJF;AACF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,2BAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,yDAAA;EACA,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,sFAAA;AALF;AAOE;EAEE,aAAA;EACA,sCAAA;EACA,oDAAA;AANJ;AASE;EACE,sBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oDAAA;AARJ;AAUI;EACE,eAAA;AARN;AAYE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAVJ","sourcesContent":["/* Building part type picker: header + grid of tiles (2 columns on phones, 3 from tablet up).\n * The host is the modal page (.ion-page, flex column): the grid scrolls, the header stays. */\n:host {\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.category-picker__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: 16px 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.3;\n  }\n}\n\n.category-picker__close {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 22px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n}\n\n.category-picker__body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 16px 16px calc(16px + var(--ion-safe-area-bottom));\n}\n\n.category-picker__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  // Every row as tall as the tallest one, so all tiles share the same height\n  // even when a name wraps on two lines\n  grid-auto-rows: 1fr;\n  gap: 12px;\n\n  @media (min-width: 576px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.category-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  // Content from the top: icons line up across tiles, only the name takes one or two lines\n  justify-content: flex-start;\n  gap: 10px;\n  height: 100%;\n  min-height: 112px;\n  padding: 18px 10px 16px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 12px;\n  background: var(--ion-background-color, #fff);\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    border-color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.06);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n\n    ion-icon {\n      font-size: 26px;\n    }\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.3;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
